import merge from 'deepmerge'
import { useMatches, useRouteLoaderData } from 'react-router'

import layouts from '~/layouts'
import { AppLoaderData, PortalRouteMatch } from '~/types/app'
import { LayoutType, PageLayout } from '~/types/layout'

export const usePageLayout = (): PageLayout => {
  const matches: PortalRouteMatch[] = useMatches()
  const { layout = LayoutType.DEFAULT } = useRouteLoaderData('root') as AppLoaderData
  let mergedLayout = layouts[layout] || layouts[LayoutType.DEFAULT] || {} as PageLayout

  for (const match of matches) {
    if (match.handle?.layout?.[layout]) {
      mergedLayout = merge(mergedLayout, match.handle.layout?.[layout])
    }
  }
  
  return mergedLayout!
}